import { Ionicons } from "@expo/vector-icons";
import { Button, Icon, useMediaQuery } from "native-base";
import React from "react";
import { DOTS, usePagination } from "./usePagination";

const AppPagination = (props) => {
	const desktop = useMediaQuery({ minWidth: 960 })[0];
	const {
		onPageChange,
		totalCount,
		siblingCount = 1,
		currentPage,
		pageSize,
		className,
	} = props;

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize,
	});

	// If there are less than 2 times in pagination range we shall not render the component
	if (currentPage === 0 || paginationRange.length < 2) {
		return null;
	}

	const onNext = () => {
		onPageChange(currentPage + 1);
	};

	const onPrevious = () => {
		onPageChange(currentPage - 1);
	};

	let lastPage = paginationRange[paginationRange.length - 1];
	return (
		<Button.Group size={desktop ? "lg" : "sm"}>
			<Button
				borderRadius={4}
				width={8}
				height={8}
				onPress={onPrevious}
				isDisabled={currentPage === 1}
				endIcon={<Icon as={Ionicons} name="chevron-back" size="sm" />}
			></Button>
			{paginationRange.map((pageNumber) => {
				// If the pageItem is a DOT, render the DOTS unicode character
				if (pageNumber === DOTS) {
					return (
						<Button
							borderRadius={4}
							width={8}
							height={8}
							key={pageNumber}
							variant={"outline"}
							isDisabled
						>
							...
						</Button>
					);
				}
				// Render our Page Pills
				return (
					<Button
						borderRadius={4}
						width={8}
						height={8}
						key={pageNumber}
						variant={pageNumber === currentPage ? "solid" : "outline"}
						onPress={() => onPageChange(pageNumber)}
					>
						{pageNumber}
					</Button>
				);
			})}
			<Button
				borderRadius={4}
				width={8}
				height={8}
				isDisabled={currentPage === lastPage}
				onPress={onNext}
				endIcon={<Icon as={Ionicons} name="chevron-forward" size="sm" />}
			></Button>
		</Button.Group>
	);
};

export default AppPagination;
